import { getWixThumbnailsUrls } from '@wix/thumbnail-generator';
import { splitTags, get } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toItem(itemData, settings, thumbnailSizes) {
  const item = {
    id: itemData.guid,
    name: itemData.title,
    mediaType: itemData.mediaType,
    kind: ItemKind.File,
    source: 'public',
    fileName: itemData.fileName,
    fileUrl: itemData.fileUrl,
    createdAt: null,
    tags: splitTags(itemData.tags),
    tagsEn: splitTags(itemData.tagsEn),
    systemTags: splitTags(itemData.systemTags),
    width: itemData.width,
    height: itemData.height,
    fileOutput: itemData.fileOutput || null,
    fileInput: itemData.fileInput ? itemData.fileInput : itemData.mediaType === MediaType.Video ? {
      duration: itemData.videoDuration
    } : {},
    vendor: itemData.vendor || null,
    reference: itemData.reference || null,
    creator: itemData.creator || null,
    creatorPicture: itemData.creatorPicture ? "media/" + itemData.creatorPicture : null,
    externalId: itemData.externalId || null,
    subtype: itemData.subtype || null,
    videoThumbnailUrl: itemData.videoThumbnailUrl || get(itemData, 'fileOutput.image[0].url', null),
    previewUrl: itemData.previewUrl || null
  };
  if (itemData.thumbnailUrl && itemData.fileUrl) {
    const folderName = itemData.fileUrl.split('/')[0];
    item.thumbnailUrl = folderName + "/" + itemData.thumbnailUrl;
  }
  if (itemData.videoPreviewUrl) {
    item.videoPreviewUrls = [settings.videoFilesUrl + "/" + itemData.videoPreviewUrl];
  }
  const itemFileOutputVideoUrl = get(itemData, 'fileOutput.video[0].url');
  if (itemFileOutputVideoUrl) {
    item.videoPreviewUrls = [settings.videoFilesUrl + "/" + itemFileOutputVideoUrl];
  }
  const sizes = {
    ...settings.thumbnailSizes,
    ...thumbnailSizes
  };
  const thumbnailFit = sizes.thumbnailFit;
  delete sizes.thumbnailFit;
  if (/\.png$/i.test(item.fileUrl)) {
    sizes.thumbnail = thumbnailFit;
  }
  return {
    ...item,
    ...getWixThumbnailsUrls(item, sizes, settings)
  };
}